export default {"src":"/_next/static/media/hospital.790df53a.svg","height":68,"width":68,"blurWidth":0,"blurHeight":0};